import { Form } from '@unistocks/components/form/form';
import { DateConstant, PieChartType } from '@unistocks/proxy/axios-client';
import { t } from '@unistocks/shared/localization/index.ts';
import { mapEnumToOptions, translateEnumOptions } from '@unistocks/shared/utils/enum-utils';

const pieChartTypeOptions = mapEnumToOptions(PieChartType, 'PieChartType');

export type PieChartTypeSelectProps = {
  name: string;
  invalidOptions?: DateConstant[];
};

export const PieChartTypeSelect: React.FC<PieChartTypeSelectProps> = ({ name }) => {
  return (
    <Form.RadioGroup
      name={name}
      label={t('::Dashboard:Settings:ChartType')}
      options={translateEnumOptions(pieChartTypeOptions)}
      isRequired
    />
  );
};
